"use strict";
/*
 * Created on 9. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Hints for release editing.
 * @author Radek Beran
 */


var ReleaseEditInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseEditInfo, _DomainObject_1$Domai);

  /**
   * @param settingsEditable true if release settings can be edited
   */
  function ReleaseEditInfo(settingsEditable) {
    var _this;

    _classCallCheck(this, ReleaseEditInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseEditInfo).call(this));
    _this.settingsEditable = settingsEditable;
    return _this;
  }

  return ReleaseEditInfo;
}(DomainObject_1.DomainObject);

exports.ReleaseEditInfo = ReleaseEditInfo;

ReleaseEditInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReleaseEditInfo.name);
  return {
    settingsEditable: builder.bool('settingsEditable')
  };
}();